import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {BrowserRouter} from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Base64 } from 'js-base64';
import "react-responsive-modal/styles.css";
import './assets/css/owl.carousel.min.css';
import './assets/scss/styles.scss';

const initialState = ((window as any).DATA !== null && (window as any).DATA !== '{{WINDOW_DATA}}')
  ? Base64.decode((window as any).DATA) : '{}';
const ssrData = JSON.parse(initialState).ssrData;
const name = initialState === '{}' ? 'render' : 'hydrate';

ReactDOM[name](
  <HelmetProvider>
      <BrowserRouter>
        <App ssrData={ssrData} />
      </BrowserRouter>
  </HelmetProvider>,
  document.getElementById('root')
);